import fr from 'facet-rest';

export const SET_COLLECTION = 'SET_COLLECTION';
export const ERROR_STATE = 'ERROR_STATE';
export const LOADING_STATE = 'LOADING_STATE';
export const SET_ACCOUNT_TYPES = 'SET_ACCOUNT_TYPES';
export const SET_EXCLUDED_ACCOUNT_IDS = 'SET_EXCLUDED_ACCOUNT_IDS';
export const SET_SECURITY_TYPE = 'SET_SECURITY_TYPE';

export function setPortfolioError(error) {
  return { type: ERROR_STATE, error: error.message };
}

export async function loadFromLink(relationship, dispatch) {
  const isLink = relationship instanceof fr.Link;
  if (!isLink) {
    throw new TypeError('Portfolio must be a resource');
  }

  try {
    dispatch({ type: LOADING_STATE, loading: true });
    const collection = await relationship.get();
    dispatch({ type: SET_COLLECTION, collection });
    const selfSearch = new URL(relationship.url()).searchParams;
    const types = selfSearch
      .get('accountTypeMultipicklist')?.toString()
      .slice(3)
      .split(',');

    const excludedIds = selfSearch
      .get('excludedAccountIds')?.toString()
      .slice(4)
      .split(',') || [];

    dispatch({ type: SET_EXCLUDED_ACCOUNT_IDS, ids: excludedIds });
    dispatch({ type: SET_ACCOUNT_TYPES, accountTypes: types });
  } catch (e) {
    dispatch(setPortfolioError(e));
  } finally {
    dispatch({ type: LOADING_STATE, loading: false });
  }
}

export async function refreshPortfolioCollection(dispatch, state) {
  try {
    const { portfolioCollection } = state;
    dispatch({ type: LOADING_STATE, loading: true });
    const collection = await portfolioCollection.refresh();
    dispatch({ type: SET_COLLECTION, collection });
  } catch (e) {
    dispatch(setPortfolioError(e));
  } finally {
    dispatch({ type: LOADING_STATE, loading: false });
  }
}

export async function queryBySecurityType(typeArg, dispatch, state) {
  try {
    const {
      selfLink,
      securityType,
      excludedAccountIds,
      accountTypes,
    } = state;

    const type = typeArg === securityType ? null : typeArg;

    dispatch({ type: LOADING_STATE, loading: true });
    dispatch({ type: SET_SECURITY_TYPE, securityType: type });
    const rel = selfLink.copy();
    if (type) {
      rel.equal('securityType', type);
    } else {
      rel.removeSearchParam('securityType');
    }

    rel.in('accountTypeMultipicklist', accountTypes);

    if (excludedAccountIds?.length) {
      rel.notIn('excludedAccountIds', excludedAccountIds);
    }

    const collection = await rel.get();
    dispatch({ type: SET_COLLECTION, collection });
  } catch (e) {
    dispatch(setPortfolioError(e));
  } finally {
    dispatch({ type: LOADING_STATE, loading: false });
  }
}

export async function toggleAccountType(type, dispatch, state) {
  try {
    dispatch({ type: LOADING_STATE, loading: true });
    const { selfLink, excludedAccountIds, accountTypes } = state;
    const types = accountTypes.includes(type)
      ? accountTypes.filter(t => t !== type)
      : [type, ...accountTypes];

    dispatch({ type: SET_ACCOUNT_TYPES, accountTypes: types });
    const linkForQuery = selfLink.copy();
    linkForQuery.in('accountTypeMultipicklist', types);

    if (excludedAccountIds?.length) {
      linkForQuery.notIn('excludedAccountIds', excludedAccountIds);
    }

    const collection = await linkForQuery.get();
    dispatch({ type: SET_COLLECTION, collection });
  } catch (e) {
    dispatch(setPortfolioError(e));
  } finally {
    dispatch({ type: LOADING_STATE, loading: false });
  }
}

export async function toggleAccount(id, dispatch, state) {
  try {
    const { selfLink, excludedAccountIds, accountTypes } = state;

    dispatch({ type: LOADING_STATE, loading: true });
    const excludedIds = excludedAccountIds.includes(id)
      ? excludedAccountIds.filter(a => a !== id)
      : [id, ...excludedAccountIds];

    dispatch({ type: SET_EXCLUDED_ACCOUNT_IDS, ids: excludedIds });

    const linkForQuery = selfLink
      .copy()
      .in('accountTypeMultipicklist', accountTypes)
      .notIn('excludedAccountIds', excludedIds);

    const collection = await linkForQuery.get();
    dispatch({ type: SET_COLLECTION, collection });
  } catch (e) {
    dispatch(setPortfolioError(e));
  } finally {
    dispatch({ type: LOADING_STATE, loading: false });
  }
}
